import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import SpBottomMenuLayout from './SpBottomMenuLayout';

type Props = {
  onClose: () => void;
  onDelete: () => void;
};

const AttachmentDeleteMenuSp = ({ onClose, onDelete }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) {
    return null;
  }

  return createPortal(
    <div className='fixed inset-0 z-[2147483647]'>
      <div
        className='absolute inset-0 bg-black/30'
        onClick={onClose}
      />

      <SpBottomMenuLayout
        handleCloseClick={onClose}
        onSwipeDown={onClose}
      >
        <div className='px-[25px] pb-8 pt-[34px]'>
          <ul className='mx-auto max-w-[340px]'>
            <li className='h-[50px]'>
              <button
                className='size-full text-left'
                onClick={() => {
                  onDelete();
                  onClose();
                }}
              >
                ファイルを削除
              </button>
            </li>
          </ul>
        </div>
      </SpBottomMenuLayout>
    </div>,
    document.body,
  );
};

export default AttachmentDeleteMenuSp;
